import * as React from "react";
const SvgIndeterminateCheckBox = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3Zm-4 10H7v-2h10v2Z",
  fill: "currentColor"
}));
export default SvgIndeterminateCheckBox;